"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../../app-reduxs/app/slice"));
const components_1 = require("../../../../components");
const CustomText_1 = __importDefault(require("../../../../components/text/CustomText"));
const constants_1 = require("../../../../constants");
const Basic_1 = __importDefault(require("../../../../networking/apis/Basic"));
const scale_1 = require("../../../../utils/scale");
const ModalUnFollow_1 = __importDefault(require("./ModalUnFollow"));
const FollowButton = (props) => {
    const { user, isAnonymous, handleUpdateUser } = props;
    const dispatch = (0, react_redux_1.useDispatch)();
    const [isFollow, setFollow] = (0, react_1.useState)(user.is_followed == 1);
    const [modalVisible, setModalVisible] = (0, react_1.useState)(false);
    const [modalPosition, setModalPosition] = (0, react_1.useState)({ x: 0, y: 0 });
    const refIsCallingAPI = (0, react_1.useRef)(false);
    const handleUnfollowUser = () => {
        if (isAnonymous) {
            return dispatch(slice_1.default.actions.showRequestLoginModal());
        }
        if (refIsCallingAPI.current)
            return;
        refIsCallingAPI.current = true;
        Basic_1.default.unfollowUser(user.user_id)
            .then(() => {
            dispatch(slice_1.default.actions.showToast(`${user.nickname || constants_1.DEFAULT_NAME}さんをフォロー解除しました`));
            handleUpdateUser();
            setFollow(false);
            setModalVisible(false);
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => {
            refIsCallingAPI.current = false;
        });
    };
    const handleFollowUser = () => {
        if (isAnonymous) {
            return dispatch(slice_1.default.actions.showRequestLoginModal());
        }
        if (refIsCallingAPI.current)
            return;
        refIsCallingAPI.current = true;
        Basic_1.default.followUser(user.user_id)
            .then(() => {
            dispatch(slice_1.default.actions.showToast(`${user.nickname || constants_1.DEFAULT_NAME}さんをフォローしました`));
            setFollow(true);
            handleUpdateUser();
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => {
            refIsCallingAPI.current = false;
        });
    };
    const buttonUnFollowRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isFollow ? (react_1.default.createElement(react_native_1.View, { style: [
                styles.buttonContainer,
                !!user.is_followed && { marginRight: (0, scale_1.scale)(12) },
            ] },
            react_1.default.createElement(react_native_1.TouchableOpacity, { ref: buttonUnFollowRef, style: [styles.followButton, { backgroundColor: '#DDDDDD' }], onPress: (event) => {
                    const { pageY } = event.nativeEvent;
                    const position = buttonUnFollowRef.current?.getBoundingClientRect();
                    setModalPosition({ x: position.right, y: position.bottom });
                    setModalVisible(true);
                } },
                react_1.default.createElement(CustomText_1.default, { style: [styles.followButtonLabel, { color: '#545454' }] }, "\u30D5\u30A9\u30ED\u30FC\u4E2D")))) : (react_1.default.createElement(components_1.LinearButton, { title: "\u30D5\u30A9\u30ED\u30FC", onPress: handleFollowUser, containerStyle: [
                styles.buttonContainer,
                !!user.is_followed && { marginRight: (0, scale_1.scale)(12) },
            ], style: styles.followButton })),
        react_1.default.createElement(ModalUnFollow_1.default, { modalPosition: modalPosition, visible: modalVisible, onClose: () => setModalVisible(false), openModalNoti: handleUnfollowUser, hashTag: user.nickname || constants_1.DEFAULT_NAME })));
};
exports.default = FollowButton;
const styles = react_native_1.StyleSheet.create({
    buttonContainer: {
        // position: 'relative',
        flex: 1,
        zIndex: 1,
    },
    followButton: {
        width: '100%',
        height: (0, scale_1.scale)(32),
        borderRadius: (0, scale_1.scale)(3),
        justifyContent: 'center',
        alignItems: 'center',
    },
    followButtonLabel: {
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        color: '#FEFEFE',
    },
    viewLine: {
        flex: 1,
        paddingHorizontal: (0, scale_1.scale)(16),
        paddingVertical: (0, scale_1.scale)(8),
    },
    textNote: {
        color: '#D32F2F',
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
    },
});
